// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__32nsk","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__fdDDc"};